import React from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { HasAccessTo } from "./HasAccessTo";
export const RestrictAccess = ({ entity, permission }) => {
  const { userId } = useParams();
  const location = useLocation();
  return HasAccessTo(entity, permission, userId) ? /* @__PURE__ */ React.createElement(Outlet, null) : /* @__PURE__ */ React.createElement(Navigate, { to: "/not-allowed", state: { from: location }, replace: true });
};
